import getPayeService from '../../../api/envService'
import { VARIABLE_CONTEXTE_ENDPOINT } from '../../../api/endpoints'
import { setLoader } from '../loader-action'
import { SET_VARIABLE_CONTEXTES } from '../../reducers/fonction/variable-contexte-reducer'

export const setVariableContextes = models => {
  return { type: SET_VARIABLE_CONTEXTES, value: models }
}

export const getVariableContextes = () => dispatch =>
  Promise.resolve()
    .then(() => dispatch(setLoader(true)))
    .then(() => getPayeService().get(VARIABLE_CONTEXTE_ENDPOINT))
    .then(models => dispatch(setVariableContextes(models)))
    .finally(() => dispatch(setLoader()))

export const createVariableContexte = variableContexte => dispatch =>
  Promise.resolve()
    .then(() => getPayeService().post(VARIABLE_CONTEXTE_ENDPOINT, variableContexte))
    .then(() => dispatch(getVariableContextes()))
    .catch(e => {
      console.log(e)
    })

export const updateVariableContexte = variableContexte => dispatch =>
  Promise.resolve()
    .then(() => getPayeService().put(VARIABLE_CONTEXTE_ENDPOINT, variableContexte))
    .then(() => dispatch(getVariableContextes()))
    .catch(e => {
      console.log(e)
    })

export const deleteVariableContexte = nom => dispatch => {
  return Promise.resolve()
    .then(() => dispatch(setLoader(true)))
    .then(() => getPayeService().deleteById(VARIABLE_CONTEXTE_ENDPOINT, nom))
    .then(() => dispatch(getVariableContextes()))
    .finally(() => dispatch(setLoader(false)))
}
